import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const StyledStepContainer = styled.div`
  margin-top: 4.625rem 0 0 0;

  ${mediaQuery('md')} {
    margin: 4.625rem 0;
  }
`;
